import staticConfig from '@config/static-config';
import { UnsupportedError } from '@errors';
import { EthChainId } from '@types';

const { cronos } = staticConfig;

export const getChainInfo = (chain: EthChainId) => {
  switch (chain) {
    case EthChainId.Mainnet:
      return cronos.chainInfo.ethereum;
    case EthChainId.Kovan:
      return cronos.chainInfo.kovan;
    case EthChainId.Goerli:
      return cronos.chainInfo.goerli;
    case EthChainId.Cronos:
      return cronos.chainInfo.mainnet;
    case EthChainId.CronosTestnet:
      return cronos.chainInfo.testnet;
    case EthChainId.CronosGravityTestnet:
      return cronos.chainInfo.gravityTestnet;
    default:
      throw new UnsupportedError(chain?.toString());
  }
};

export const getExtraInfo = (chain: EthChainId) => {
  switch (chain) {
    case EthChainId.Cronos:
      return cronos.extra.mainnet;
    case EthChainId.CronosTestnet:
      return cronos.extra.testnet;
    case EthChainId.CronosGravityTestnet:
      return cronos.extra.gravityTestnet;
    default:
      throw new UnsupportedError(chain?.toString());
  }
};
